/*@ngInject*/
const ReplyAllCollaborationEmailRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.replyAll = function (emailId) {
        let url = '/rest/Email/' + emailId + '/replyAll';

        return this.post(url);
    };
};

angular.module('gw-um-submission')
    .service('replyAllCollaborationEmailRepository', ReplyAllCollaborationEmailRepository);
